const Vue = require("vue");
var internalHotelList = window.internalHotelList;
var externalHotelList = window.externalHotelList;
import VuePersianDatetimePicker from "vue-persian-datetime-picker"

import { clickOutside } from "../../Helpers/directives";

// nationality data
var nationalityData = [
  { code: "IR", name: "Iran", name_fa: "ایران" },
  { code: "IO", name: "British Indian Ocean Territory", name_fa: "" },
  { code: "CC", name: "Cocos (Keeling) Islands", name_fa: "" },
  { code: "CI", name: 'Cote D"Ivoire', name_fa: "" },
  { code: "TF", name: "French Southern Territories", name_fa: "" },
  { code: "GI", name: "Gibraltar", name_fa: "" },
  { code: "GP", name: "Guadeloupe", name_fa: "" },
  { code: "GG", name: "Guernsey", name_fa: "" },
  { code: "HM", name: "Heard Island and Mcdonald Islands", name_fa: "" },
  { code: "VA", name: "Holy See (Vatican City State)", name_fa: "" },
  { code: "IM", name: "Isle of Man", name_fa: "" },
  { code: "JE", name: "Jersey", name_fa: "" },
  { code: "KI", name: "Kiribati", name_fa: "" },
  { code: "MQ", name: "Martinique", name_fa: "" },
  { code: "YT", name: "Mayotte", name_fa: "" },
  { code: "MS", name: "Montserrat", name_fa: "" },
  { code: "NC", name: "New Caledonia", name_fa: "" },
  { code: "NU", name: "Niue", name_fa: "" },
  { code: "NF", name: "Norfolk Island", name_fa: "" },
  { code: "PN", name: "Pitcairn", name_fa: "" },
  { code: "RE", name: "Reunion", name_fa: "" },
  { code: "SH", name: "Saint Helena", name_fa: "" },
  { code: "LC", name: "Saint Lucia", name_fa: "" },
  { code: "PM", name: "Saint Pierre and Miquelon", name_fa: "" },
  { code: "VC", name: "Saint Vincent and the Grenadines", name_fa: "" },
  { code: "ST", name: "Sao Tome and Principe", name_fa: "" },
  {
    code: "GS",
    name: "South Georgia and the South Sandwich Islands",
    name_fa: "",
  },
  { code: "SJ", name: "Svalbard and Jan Mayen", name_fa: "" },
  { code: "TK", name: "Tokelau", name_fa: "" },
  { code: "TC", name: "Turks and Caicos Islands", name_fa: "" },
  {
    code: "UM",
    name: "United States Minor Outlying Islands",
    name_fa: "",
  },
  { code: "VG", name: "Virgin Islands, British", name_fa: "" },
  { code: "VI", name: "Virgin Islands, U.S.", name_fa: "" },
  { code: "WF", name: "Wallis and Futuna", name_fa: "" },
  { code: "AQ", name: "Antarctica", name_fa: "" },
  { code: "BQ", name: "Bonaire, Sint Eustatius and Saba", name_fa: "" },
  { code: "CW", name: "Curaçao", name_fa: "" },
  { code: "BL", name: "Saint Barthélemy", name_fa: "" },
  { code: "MF", name: "Saint Martin (French part)", name_fa: "" },
  { code: "SX", name: "Sint Maarten (Dutch part)", name_fa: "" },
  { code: "SS", name: "South Sudan", name_fa: "سودان جنوبی" },
  { code: "ZW", name: "Zimbabwe", name_fa: "زیمباوه" },
  { code: "KM", name: "Comoros", name_fa: "اتحاد قمر" },
  { code: "AT", name: "Austria", name_fa: "اتریش" },
  { code: "ET", name: "Ethiopia", name_fa: "اتیوپی" },
  { code: "AZ", name: "Azerbaijan", name_fa: "آذربایجان" },
  { code: "JO", name: "Jordan", name_fa: "اردن" },
  { code: "AR", name: "Argentina", name_fa: "آرژانتین" },
  { code: "AM", name: "Armenia", name_fa: "ارمنستان" },
  { code: "AW", name: "Aruba", name_fa: "آروبا" },
  { code: "UY", name: "Uruguay", name_fa: "اروگوئه" },
  { code: "ER", name: "Eritrea", name_fa: "اریتره" },
  { code: "UZ", name: "Uzbekistan", name_fa: "ازبسکتان" },
  { code: "ES", name: "Spain", name_fa: "اسپانیا" },
  { code: "AU", name: "Australia", name_fa: "استرالیا" },
  { code: "EE", name: "Estonia", name_fa: "استونی" },
  { code: "IL", name: "Israel", name_fa: "اسراییل" },
  { code: "SK", name: "Slovakia", name_fa: "اسلوواکی" },
  { code: "SI", name: "Slovenia", name_fa: "اسلوونی" },
  { code: "ZA", name: "South Africa", name_fa: "آفریقای جنوبی" },
  { code: "AF", name: "Afghanistan", name_fa: "افغانستان" },
  { code: "EC", name: "Ecuador", name_fa: "اکوادور" },
  { code: "AL", name: "Albania", name_fa: "آلبانی" },
  { code: "DZ", name: "Algeria", name_fa: "الجزایر" },
  { code: "SV", name: "El Salvador", name_fa: "السالوادور" },
  { code: "DE", name: "Germany", name_fa: "آلمان" },
  { code: "AE", name: "United Arab Emirates", name_fa: "امارات متحده" },
  { code: "US", name: "United States", name_fa: "آمریکا" },
  {
    code: "AG",
    name: "Antigua and Barbuda",
    name_fa: "آنتیگوآ و باربودا",
  },
  { code: "AN", name: "Netherlands Antilles", name_fa: "آنتیل هلند" },
  { code: "AD", name: "AndorrA", name_fa: "آندورا" },
  { code: "ID", name: "Indonesia", name_fa: "اندونزی" },
  { code: "GB", name: "United Kingdom", name_fa: "انگلیس" },
  { code: "AO", name: "Angola", name_fa: "آنگولا" },
  { code: "AI", name: "Anguilla", name_fa: "آنگویلا" },
  { code: "UA", name: "Ukraine", name_fa: "اوکراین" },
  { code: "UG", name: "Uganda", name_fa: "اوگاندا" },
  { code: "IT", name: "Italy", name_fa: "ایتالیا" },
  { code: "IE", name: "Ireland", name_fa: "ایرلند" },
  { code: "IS", name: "Iceland", name_fa: "ایسلند" },
  { code: "BB", name: "Barbados", name_fa: "باربادوس" },
  { code: "BS", name: "Bahamas", name_fa: "باهاما" },
  { code: "BH", name: "Bahrain", name_fa: "بحرین" },
  { code: "BR", name: "Brazil", name_fa: "برزیل" },
  { code: "BM", name: "Bermuda", name_fa: "برمودا" },
  { code: "BN", name: "Brunei Darussalam", name_fa: "برونئی" },
  { code: "BY", name: "Belarus", name_fa: "بلاروس" },
  { code: "BE", name: "Belgium", name_fa: "بلژیک" },
  { code: "BG", name: "Bulgaria", name_fa: "بلغارستان" },
  { code: "BZ", name: "Belize", name_fa: "بلیز" },
  { code: "BD", name: "Bangladesh", name_fa: "بنگلادش" },
  { code: "BJ", name: "Benin", name_fa: "بنین" },
  { code: "BT", name: "Bhutan", name_fa: "بوتان" },
  { code: "BW", name: "Botswana", name_fa: "بوتسوانا" },
  { code: "BF", name: "Burkina Faso", name_fa: "بورکینافاسو" },
  { code: "BI", name: "Burundi", name_fa: "بوروندی" },
  {
    code: "BA",
    name: "Bosnia and Herzegovina",
    name_fa: "بوسنی و هرزگوین",
  },
  { code: "BO", name: "Bolivia", name_fa: "بولیوی" },
  { code: "PG", name: "Papua New Guinea", name_fa: "پاپوا گینه نو" },
  { code: "PY", name: "Paraguay", name_fa: "پاراگوئه" },
  { code: "PK", name: "Pakistan", name_fa: "پاکستان" },
  { code: "PW", name: "Palau", name_fa: "پالائو" },
  { code: "PA", name: "Panama", name_fa: "پاناما" },
  { code: "PT", name: "Portugal", name_fa: "پرتغال" },
  { code: "PE", name: "Peru", name_fa: "پرو" },
  { code: "PR", name: "Puerto Rico", name_fa: "پورتو ریکو" },
  { code: "PF", name: "French Polynesia", name_fa: "پولینزی فرانسوی" },
  { code: "TJ", name: "Tajikistan", name_fa: "تاجیکستان" },
  {
    code: "TZ",
    name: "Tanzania, United Republic of",
    name_fa: "تانزانیا",
  },
  { code: "TH", name: "Thailand", name_fa: "تایلند" },
  { code: "TW", name: "Taiwan, Province of China", name_fa: "تایوان" },
  { code: "TM", name: "Turkmenistan", name_fa: "ترکمنستان" },
  { code: "TR", name: "Turkey", name_fa: "ترکیه" },
  { code: "TT", name: "Trinidad and Tobago", name_fa: "ترینیداد" },
  { code: "TG", name: "Togo", name_fa: "توگو" },
  { code: "TN", name: "Tunisia", name_fa: "تونس" },
  { code: "TO", name: "Tonga", name_fa: "تونگا" },
  { code: "TV", name: "Tuvalu", name_fa: "تووالو" },
  { code: "TL", name: "Timor-Leste", name_fa: "تیمور شرقی" },
  { code: "JM", name: "Jamaica", name_fa: "جاماییکا" },
  { code: "AX", name: "land Islands", name_fa: "جزایر الند" },
  { code: "SB", name: "Solomon Islands", name_fa: "جزایر سلیمان" },
  { code: "FO", name: "Faroe Islands", name_fa: "جزایر فارو" },
  {
    code: "FK",
    name: "Falkland Islands (Malvinas)",
    name_fa: "جزایر فالکلند",
  },
  { code: "CX", name: "Christmas Island", name_fa: "جزایر کریسمس" },
  { code: "CK", name: "Cook Islands", name_fa: "جزایر کوک" },
  { code: "KY", name: "Cayman Islands", name_fa: "جزایر کیمن" },
  { code: "MH", name: "Marshall Islands", name_fa: "جزایر مارشال" },
  {
    code: "MP",
    name: "Northern Mariana Islands",
    name_fa: "جزایر ماریان شمالی",
  },
  { code: "BV", name: "Bouvet Island", name_fa: "جزیره بووه" },
  {
    code: "CF",
    name: "Central African Republic",
    name_fa: "جمهوری آفریقای مرکزی",
  },
  { code: "CZ", name: "Czech Republic", name_fa: "جمهوری چک" },
  {
    code: "CD",
    name: "Congo, The Democratic Republic of the",
    name_fa: "جمهوری دموکراتیک کنگو",
  },
  { code: "DO", name: "Dominican Republic", name_fa: "جمهوری دومینیکن" },
  { code: "DJ", name: "Djibouti", name_fa: "جیبوتی" },
  { code: "TD", name: "Chad", name_fa: "چاد" },
  { code: "CN", name: "China", name_fa: "چین" },
  { code: "DK", name: "Denmark", name_fa: "دانمارک" },
  { code: "DM", name: "Dominica", name_fa: "دومینیکا" },
  { code: "RW", name: "RWANDA", name_fa: "رواندا" },
  { code: "RU", name: "Russian Federation", name_fa: "روسیه" },
  { code: "RO", name: "Romania", name_fa: "رومانی" },
  { code: "ZM", name: "Zambia", name_fa: "زامبیا" },
  { code: "Z", name: "Zimbabw", name_fa: "زیمباوه" },
  { code: "JP", name: "Japan", name_fa: "ژاپن" },
  { code: "WS", name: "Samoa", name_fa: "ساموآ" },
  { code: "AS", name: "American Samoa", name_fa: "ساموآی آمریکا" },
  { code: "LK", name: "Sri Lanka", name_fa: "سریلانکا" },
  { code: "SM", name: "San Marino", name_fa: "سن مارینو" },
  {
    code: "KN",
    name: "Saint Kitts and Nevis",
    name_fa: "سنت کیتس و نویس",
  },
  { code: "SG", name: "Singapore", name_fa: "سنگاپور" },
  { code: "SN", name: "Senegal", name_fa: "سنگال" },
  { code: "SZ", name: "Swaziland", name_fa: "سوازیلند" },
  { code: "SD", name: "Sudan", name_fa: "سودان" },
  { code: "SR", name: "Suriname", name_fa: "سورینام" },
  { code: "SY", name: "Syrian Arab Republic", name_fa: "سوریه" },
  { code: "SO", name: "Somalia", name_fa: "سومالی" },
  { code: "SE", name: "Sweden", name_fa: "سوئد" },
  { code: "CH", name: "Switzerland", name_fa: "سوییس" },
  { code: "SL", name: "Sierra Leone", name_fa: "سیرالئون" },
  { code: "SC", name: "Seychelles", name_fa: "سیشل" },
  { code: "CL", name: "Chile", name_fa: "شیلی" },
  { code: "EH", name: "Western Sahara", name_fa: "صحرای غربی" },
  { code: "RS", name: "Serbia", name_fa: "صربستان" },
  { code: "IQ", name: "Iraq", name_fa: "عراق" },
  { code: "SA", name: "Saudi Arabia", name_fa: "عربستان" },
  { code: "OM", name: "Oman", name_fa: "عمان" },
  { code: "GH", name: "Ghana", name_fa: "غنا" },
  { code: "FR", name: "France", name_fa: "فرانسه" },
  {
    code: "PS",
    name: "Palestinian Territory, Occupied",
    name_fa: "فلسطین",
  },
  { code: "FI", name: "Finland", name_fa: "فنلاند" },
  { code: "FJ", name: "Fiji", name_fa: "فیجی" },
  { code: "PH", name: "Philippines", name_fa: "فیلیپین" },
  { code: "CY", name: "Cyprus", name_fa: "قبرس" },
  { code: "KG", name: "Kyrgyzstan", name_fa: "قرقیزستان" },
  { code: "KZ", name: "Kazakhstan", name_fa: "قزاقستان" },
  { code: "QA", name: "Qatar", name_fa: "قطر" },
  { code: "CR", name: "Costa Rica", name_fa: "کاستاریکا" },
  { code: "KH", name: "Cambodia", name_fa: "کامبوج" },
  { code: "CM", name: "Cameroon", name_fa: "کامرون" },
  { code: "CA", name: "Canada", name_fa: "کانادا" },
  { code: "KR", name: "Korea, Republic of", name_fa: "کره جنوبی" },
  {
    code: "KP",
    name: 'Korea, Democratic People"S Republic of',
    name_fa: "کره شمالی",
  },
  { code: "HR", name: "Croatia", name_fa: "کرواسی" },
  { code: "CO", name: "Colombia", name_fa: "کلمبیا" },
  { code: "CG", name: "Congo", name_fa: "کنگو" },
  { code: "KE", name: "Kenya", name_fa: "کنیا" },
  { code: "CU", name: "Cuba", name_fa: "کوبا" },
  { code: "KW", name: "Kuwait", name_fa: "کویت" },
  { code: "CV", name: "Cape Verde", name_fa: "کیپ ورد" },
  { code: "GA", name: "Gabon", name_fa: "گابن" },
  { code: "GM", name: "Gambia", name_fa: "گامیا" },
  { code: "GD", name: "Grenada", name_fa: "گرانادا" },
  { code: "GE", name: "Georgia", name_fa: "گرجستان" },
  { code: "GL", name: "Greenland", name_fa: "گرینلند" },
  { code: "GT", name: "Guatemala", name_fa: "گواتمالا" },
  { code: "GU", name: "Guam", name_fa: "گوام" },
  { code: "GY", name: "Guyana", name_fa: "گویان" },
  { code: "GF", name: "French Guiana", name_fa: "گویان فرانسه" },
  { code: "GN", name: "Guinea", name_fa: "گینه" },
  { code: "GQ", name: "Equatorial Guinea", name_fa: "گینه استوایی" },
  { code: "GW", name: "Guinea-Bissau", name_fa: "گینه بیسائو" },
  { code: "LV", name: "Latvia", name_fa: "لاتویا" },
  {
    code: "LA",
    name: 'Lao People"S Democratic Republic',
    name_fa: "لائوس",
  },
  { code: "LB", name: "Lebanon", name_fa: "لبنان" },
  { code: "LS", name: "Lesotho", name_fa: "لسوتو" },
  { code: "PL", name: "Poland", name_fa: "لهستان" },
  { code: "LU", name: "Luxembourg", name_fa: "لوگزامبورگ" },
  { code: "LR", name: "Liberia", name_fa: "لیبریا" },
  { code: "LY", name: "Libyan Arab Jamahiriya", name_fa: "لیبی" },
  { code: "LT", name: "Lithuania", name_fa: "لیتوانی" },
  { code: "LI", name: "Liechtenstein", name_fa: "لیختنشتاین" },
  { code: "MG", name: "Madagascar", name_fa: "ماداگاسکار" },
  { code: "MO", name: "Macao", name_fa: "ماکائو" },
  { code: "MW", name: "Malawi", name_fa: "مالاوی" },
  { code: "MT", name: "Malta", name_fa: "مالت" },
  { code: "MV", name: "Maldives", name_fa: "مالدیو" },
  { code: "MY", name: "Malaysia", name_fa: "مالزی" },
  { code: "ML", name: "Mali", name_fa: "مالی" },
  { code: "HU", name: "Hungary", name_fa: "مجارستان" },
  { code: "MA", name: "Morocco", name_fa: "مراکش" },
  { code: "EG", name: "Egypt", name_fa: "مصر" },
  { code: "MN", name: "Mongolia", name_fa: "مغولستان" },
  {
    code: "MK",
    name: "Macedonia, The Former Yugoslav Republic of",
    name_fa: "مقدونیه",
  },
  { code: "MX", name: "Mexico", name_fa: "مکزیک" },
  { code: "MR", name: "Mauritania", name_fa: "موریتانی" },
  { code: "MU", name: "Mauritius", name_fa: "موریس" },
  { code: "MZ", name: "Mozambique", name_fa: "موزامبیک" },
  { code: "MD", name: "Moldova, Republic of", name_fa: "مولداوی" },
  { code: "MC", name: "Monaco", name_fa: "موناکو" },
  { code: "ME", name: "Montenegro", name_fa: "مونتنگرو" },
  { code: "MM", name: "Myanmar", name_fa: "میانمار" },
  {
    code: "FM",
    name: "Micronesia, Federated States of",
    name_fa: "میکرونزی",
  },
  { code: "NA", name: "Namibia", name_fa: "نامیبیا" },
  { code: "NR", name: "Nauru", name_fa: "نائورو" },
  { code: "NP", name: "Nepal", name_fa: "نپال" },
  { code: "NO", name: "Norway", name_fa: "نروژ" },
  { code: "NE", name: "Niger", name_fa: "نیجر" },
  { code: "NG", name: "Nigeria", name_fa: "نیجریه" },
  { code: "NI", name: "Nicaragua", name_fa: "نیکاراگوئه" },
  { code: "NZ", name: "New Zealand", name_fa: "نیوزیلند" },
  { code: "HT", name: "Haiti", name_fa: "هاییتی" },
  { code: "NL", name: "Netherlands", name_fa: "هلند" },
  { code: "IN", name: "India", name_fa: "هند" },
  { code: "HN", name: "Honduras", name_fa: "هندوراس" },
  { code: "HK", name: "Hong Kong", name_fa: "هنگ‌کنگ" },
  { code: "VU", name: "Vanuatu", name_fa: "وانواتو" },
  { code: "VE", name: "Venezuela", name_fa: "ونزوئلا" },
  { code: "VN", name: "Viet Nam", name_fa: "ویتنام" },
  { code: "YE", name: "Yemen", name_fa: "یمن" },
  { code: "GR", name: "Greece", name_fa: "یونان" },
];
// hotel destination component init
var hotelDestinationComponent = {
  template: "#js-hotel-destination-template",
  name: "hotel-destination",
  props: {
    destinationType: {
      type: Number,
    },

    title: {
      type: String,
    },

    mobileTitle: {
      type: String,
    },
  },

  data: function () {
    return {
      inputValue: "",
      showList: false,
      hotelsList: "",
      defaultList: [],
      showDefaultList: true,
      notFound: false,
      selectedHotel: false,
      mobilePlaceholder: this.mobileTitle + " مورد نظرتان را جستجو کنید",
      showLoading: false,
      baseUrl: "/hotelBooking-api/searchtitle/",
      temp: "",
      hotel: "",
      setTimeout: "",
    };
  },

  methods: {
    showDefaultHotels: function () {
      // show defaul hotels

      var self = this;
      self.showList = true;

      self.temp = self.inputValue;
      self.inputValue = "";

      // set defualt hotel from admin
      if (internalHotelList && self.destinationType === 2) {
        self.defaultList = internalHotelList;
      }

      if (externalHotelList && self.destinationType !== 2) {
        self.defaultList = externalHotelList;
      }

      if (window.innerWidth < 993) {
        setTimeout(function () {
          root.classList.add("no-scroll");
        }, 200);
      }

      setTimeout(function () {
        self.$refs.innerInput.classList.add("pl--1");
        self.$refs.innerInput.focus();
      }, 50);

      if (!self.defaultList.length) {
        axios
          .get(
            self.baseUrl +
            self.inputValue +
            "?destinationType=" +
            self.destinationType,
            {
              headers: {
                "X-Requested-With": " XMLHttpRequest",
              },
            }
          )
          .then(function (response) {
            self.defaultList = response.data.model;
            self.hotelsList = self.defaultList;
          });
      }
      self.showDefaultList = true;
      self.hotelsList = self.defaultList;
    },

    setValue: function (hotel) {
      // set input value and set search link
      this.inputValue = hotel.title;
      this.showList = false;
      this.selectedHotel = true;
      this.hotel = hotel;
      this.temp = "";

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }
    },

    close: function () {
      // close dropdown when click out of booking section
      if (this.showList) {
        this.showList = false;

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }

        if (this.temp) {
          this.inputValue = this.temp;
        }
      }

      if (!this.selectedHotel) {
        this.temp = "";
        this.inputValue = "";
      }
    },

    clearInput: function () {
      // clear input value
      this.inputValue = "";
      this.selectedHotel = false;
      this.hotel = "";
      this.locationType = "";
    },

    gethHotelList: function (event) {
      this.inputValue = event.target.value

      if (!this.inputValue.length) {
        this.showDefaultList = true;
        this.hotelsList = this.defaultList;
        this.notFound = !Boolean(this.hotelsList?.length);

        return
      }

      if (this.inputValue.length < 2) return

      // search hotel when type in input
      var self = this;

      if (self.inputValue) {
        self.$refs.innerInput.classList.remove("pl--1");
      } else {
        self.$refs.innerInput.classList.add("pl--1");
      }

      self.showLoading = true;
      self.showDefaultList = false;
      self.showList = true;
      self.selectedHotel = false;

      clearTimeout(self.setTimeout);

      self.setTimeout = setTimeout(function () {
        if (self.inputValue.length) {
          axios
            .get(
              self.baseUrl +
              self.inputValue +
              "?destinationType=" +
              self.destinationType,
              {
                headers: {
                  "X-Requested-With": " XMLHttpRequest",
                },
              }
            )
            .then(function (response) {
              self.hotelsList = [];
              if (response.data.model.length) {
                self.hotelsList = response.data.model;
                self.notFound = false;
              } else {
                self.notFound = true;
              }
            });
        } else {
          self.showDefaultList = true;
          self.hotelsList = self.defaultList;
          self.notFound = false;
        }

        self.showLoading = false;

        self.$refs.innerInput.focus();
      }, 400);
    }

  },

  directives: {
    "click-outside": clickOutside,
  },
};

// hotel datepicker component
var hotelDatepickerComponent = {
  template: "#js-hotel-datepicker-template",
  props: {
    title: {
      type: String,
    },

    minDate: {
      default: moment(Date().now).format("jYYYY/jMM/jDD"),
    },

    type: {
      type: String,
    },

    dateLocale: {
      type: String,
    },

    dateFormat: {
      type: String,
    },
  },

  data: function () {
    return {
      date: "",
      color: "#e30713",
      open: false,
      showGoToDayButton: true,
    };
  },

  components: {
    "date-picker": VuePersianDatetimePicker,
  },

  methods: {
    openDatepicker: function () {
      // open datepicker
      if (window.innerWidth < 993) {
        setTimeout(function () {
          root.classList.add("no-scroll");
        }, 200);
      }

      this.$refs.datepicker.updateDates();

      this.open = true;
    },

    closeDatepicker: function () {
      // close datepicker
      this.open = false;

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }
    },

    isToday(input) {
      var toDay = moment(new Date()).format("YYYY/MM/DD");
      var inputDate = moment(input.date).format("YYYY/MM/DD");

      if (toDay === inputDate) {
        return "is-today";
      } else {
        return "";
      }
    },

    close: function () {
      this.$refs.datepicker.visible = false;
    },

    changeLocale: function (type) {
      this.$emit("change-locale", type);
    },

    changedDate: function (event) {
      if (this.type === "entryDate") {
        // send date to parent on date changed
        this.$emit("date-changed", event);
      }
    },

    goToDay: function () {
      this.date = moment(new Date()).format("jYYYY/jMM/jDD");

      this.changedDate();
    },
  },

  watch: {
    minDate: function () {
      var toDay = moment(new Date()).format("YYYY/MM/DD");
      var minDate = moment(this.minDate, "jYYYY/jMM/jDD").locale("en").format("YYYY/MM/DD");

      var duration = moment(minDate).diff(toDay, "days");

      this.showGoToDayButton = duration > 0 ? false : true;
    },
  },

  directives: {
    "click-outside": clickOutside,
  },
};

// hotel nationality component init
var hotelNationalityComponent = {
  template: "#js-hotel-nationality-template",
  name: "hotel-nationality",
  data: function () {
    return {
      inputValue: "ایران",
      nationalityCode: "Ir",
      showList: false,
      nationalityList: [],
      defaultList: nationalityData,
      showDefaultList: true,
      notFound: false,
      selectedNationality: true,
      showLoading: false,
      temp: "",
      setTimeout: "",
    };
  },

  methods: {
    showDefaultNationalityList: function () {
      // show defaul list
      this.showList = true;

      this.showDefaultList = true;
      this.nationalityList = this.defaultList;

      this.notFound = false;

      var self = this;

      if (window.innerWidth < 993) {
        setTimeout(function () {
          root.classList.add("no-scroll");
        }, 200);
      }

      setTimeout(function () {
        self.$refs.innerInput.classList.add("pl--1");
        self.$refs.innerInput.focus();
      }, 50);
    },

    setValue: function (nationality) {
      // set input value
      this.inputValue = nationality.name_fa;
      this.nationalityCode = nationality.code;
      this.showList = false;
      this.selectedNationality = true;
      this.temp = "";

      if (window.innerWidth < 993) {
        root.classList.remove("no-scroll");
      }
    },

    close: function (e) {
      // close dropdown when click out of booking section
      if (this.showList) {
        this.showList = false;

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }

        if (this.temp) {
          this.inputValue = this.temp;
        }
      }
    },

    clearInput: function () {
      // clear input value
      this.inputValue = "";
      this.nationalityCode = "";
      this.selectedNationality = false;
      this.temp = "";
    },

    gethNationalityList: function (event) {
      // search nationality when type in input
      this.inputValue = event.target.value

      if (!this.inputValue.length) {
        this.showDefaultList = true;
        this.nationalityList = this.defaultList;
        this.notFound = !Boolean(this.nationalityList?.length);

        return
      }

      if (this.inputValue.length < 2) return

      var self = this;

      if (self.inputValue) {
        self.$refs.innerInput.classList.remove("pl--1");
      } else {
        self.$refs.innerInput.classList.add("pl--1");
      }

      self.showLoading = true;
      self.showDefaultList = false;
      self.showList = true;
      self.selectedNationality = false;

      clearTimeout(self.setTimeout);

      self.setTimeout = setTimeout(function () {
        self.nationalityList = [];

        var regExp = new RegExp(self.inputValue.toLowerCase(), "i");

        var filteredItems = nationalityData.filter(function (item) {
          return item.name_fa.match(regExp);
        });

        if (filteredItems.length) {
          self.nationalityList = filteredItems;
        } else {
          self.nationalityList = [];
          self.notFound = true;
        }

        self.showLoading = false;

        self.$refs.innerInput.focus();
      }, 400);
    },
  },

  directives: {
    "click-outside": clickOutside,
  },
};

// hotel travellers component init
var hotelTravellersComponent = {
  template: "#js-hotel-travellers-template",
  name: "hotel-travellers",
  data: function () {
    return {
      showList: false,
      error: "",
      rooms: [
        {
          adults: 2,
          childs: [],
        },
      ],
      childAges: [
        {
          title: "1 - 0",
          value: 0,
        },
        {
          title: "2 - 1",
          value: 1,
        },
        {
          title: "3 - 2",
          value: 2,
        },
        {
          title: "4 - 3",
          value: 3,
        },
        {
          title: "5 - 4",
          value: 4,
        },
        {
          title: "6 - 5",
          value: 5,
        },
        {
          title: "7 - 6",
          value: 6,
        },
        {
          title: "8 - 7",
          value: 7,
        },
        {
          title: "9 - 8",
          value: 8,
        },
        {
          title: "10 - 9",
          value: 9,
        },
        {
          title: "11 - 10",
          value: 10,
        },
        {
          title: "12 - 11",
          value: 11,
        },
      ],
    };
  },

  methods: {
    goToDay: function () { },

    showTravllerList: function () {
      // show defaul list
      if (this.showList) {
        this.showList = false;
      } else {
        if (window.innerWidth < 993) {
          setTimeout(function () {
            root.classList.add("no-scroll");
          }, 200);
        }

        this.showList = true;
      }
    },

    closeTravllerList: function () {
      // close travller list
      if (this.showList) {
        this.showList = false;

        if (window.innerWidth < 993) {
          root.classList.remove("no-scroll");
        }
      }
    },

    addRoom: function () {
      // add room to list
      if (this.roomsCount < 4) {
        this.rooms.push({
          adults: 1,
          childs: [],
        });
      }
    },

    roomDelete: function (room) {
      // remove room from list
      this.rooms.splice(this.rooms.indexOf(room), 1);
    },

    addAdult: function (roomIndex) {
      // add adult to room
      if (this.rooms[roomIndex].adults < 4) {
        this.rooms[roomIndex].adults++;
      }
    },

    lowOffAdult: function (roomIndex) {
      // low off adult from room
      if (this.rooms[roomIndex].adults > 1) {
        this.rooms[roomIndex].adults--;
      }
    },

    addChild: function (roomIndex) {
      // add child to room
      if (this.rooms[roomIndex].childs.length < 4) {
        this.rooms[roomIndex].childs.push({
          value: 0,
        });
      }
    },

    lowOffChild: function (roomIndex) {
      // low off child from room
      this.rooms[roomIndex].childs.pop();
    },

    close: function (e) {
      // close dropdown when click out of booking section
      if (this.showList) {
        if (!e.target.classList.contains("js-room-delete")) {
          this.showList = false;

          if (window.innerWidth < 993) {
            root.classList.remove("no-scroll");
          }
        }
      }
    },

    setChildeAge: function (roomIndex, childIndex, event) {
      // set value to child in room
      this.rooms[roomIndex].childs[childIndex].value = event.target.value;
    },
  },

  computed: {
    roomsCount: function () {
      // return rooms count
      return this.rooms.length;
    },

    adultsCount: function () {
      //return adults count
      var adults = 0;

      this.rooms.forEach(function (room) {
        adults += room.adults;
      });

      return adults;
    },

    childsCount: function () {
      // return childs count
      var childs = 0;

      this.rooms.forEach(function (room) {
        childs += room.childs.length;
      });

      return childs;
    },
  },

  directives: {
    "click-outside": clickOutside,
  },
};

// create vue element for hotel booking
if (document.getElementById("js-hotel-booking")) {
  var HotelSearch = new Vue({
    el: "#js-hotel-booking",
    data: {
      isJalali: true,
      destinationType: 1,
      exitDateMin: moment(Date().now).format("jYYYY/jMM/jDD"),
      baseUrl: "/fa/hotel/",
      error: "",
      dateDiffError: "",
    },

    components: {
      "hotel-destination": hotelDestinationComponent,
      "hotel-datepicker": hotelDatepickerComponent,
      "hotel-nationality": hotelNationalityComponent,
      "hotel-travellers": hotelTravellersComponent,
    },

    methods: {
      changeDestinationType: function (type) {
        // change hotel destination type
        this.destinationType = type;
        this.$refs.hotelDestination.defaultList = [];
        this.$refs.hotelDestination.hotelsList = [];
      },

      changeLocale: function (type) {
        // change datepicker locale
        if (type === "fa") {
          this.isJalali = true;
        } else {
          this.isJalali = false;
        }
      },

      dateChanged: function (event) {
        // get date from entryDate and set to exitDate min
        this.exitDateMin = moment(event).add(1, 'days').format("jYYYY/jMM/jDD");
        this.$refs.exitDate.date = "";
      },

      checkValidation: function () {
        // check input is valid
        var valid = true;
        this.error = "";

        var hotelDestination = this.$refs.hotelDestination;
        var entryDate = this.$refs.entryDate;
        var exitDate = this.$refs.exitDate;
        var nationality = this.$refs.nationality;

        if (
          !hotelDestination.selectedHotel ||
          entryDate.date === "" ||
          exitDate.date === ""
        ) {
          this.error = "لطفا همه فیلدها رو پر کنید";
          valid = false;
        }

        if (this.destinationType === 1) {
          if (nationality.nationalityCode === "") {
            this.error = "لطفا همه فیلدها رو پر کنید";
            valid = false;
          }
        }

        var dateDifference = moment(exitDate.date, "YYYY/M/D").diff(
          moment(entryDate.date, "YYYY/M/D"),
          "days"
        );

        if (dateDifference > 20) {
          this.dateDiffError =
            "بازه تاریخ ورود و خروج نباید بیشتر از 20 روز باشد.";
          valid = false;
        } else {
          this.dateDiffError = "";
        }

        return valid;
      },

      searchHotel: function () {
        // search hotel
        var hotelDestination = this.$refs.hotelDestination;
        var entryDate = this.$refs.entryDate;
        var exitDate = this.$refs.exitDate;
        var travellers = this.$refs.travellers;
        var nationalityCode =
          this.destinationType === 2
            ? "Ir"
            : this.$refs.nationality.nationalityCode;

        var adultsString = "";
        var childString = "";
        var childAgeString = "";

        if (this.destinationType === 1) {
          travellers.rooms.forEach(function (room) {
            adultsString += "&a=" + room.adults;

            childString += "&c=" + room.childs.length;

            room.childs.forEach(function (child) {
              childAgeString += "&g=" + Number(child.value);
            });
          });
        } else {
          adultsString += "&a=" + 1;

          childString += "&c=" + 0;
        }

        var url = this.baseUrl;

        var valid = this.checkValidation();

        if (!valid) {
          return;
        }

        if (hotelDestination.hotel.locationType === 1) {
          url +=
            hotelDestination.hotel.countrySlug +
            "/" +
            hotelDestination.hotel.slug;
        } else if (hotelDestination.hotel.locationType === 2) {
          url +=
            hotelDestination.hotel.countrySlug +
            "/" +
            hotelDestination.hotel.citySlug +
            "/" +
            hotelDestination.hotel.slug;
        }
        url +=
          "/?i=" +
          moment(entryDate.date, "jYYYY/jM/jD").format("YYYY/M/D") +
          "&o=" +
          moment(exitDate.date, "jYYYY/jM/jD").format("YYYY/M/D") +
          "&r=" +
          travellers.roomsCount +
          "&n=" +
          nationalityCode +
          "&d=" +
          hotelDestination.hotel.id +
          "&lt=" +
          hotelDestination.hotel.locationType +
          "&dt=" +
          hotelDestination.hotel.destinationType +
          adultsString +
          childString +
          childAgeString;

        window.location.assign(url);
      },
    },
    computed: {
      locale: function () {
        return this.isJalali ? "fa" : "en";
      },

      format: function () {
        return this.isJalali ? "jYYYY/jMM/jDD" : "YYYY/MM/DD";
      },
    },
  });

  setTimeout(function () {
    document
      .querySelectorAll(".js-hotel-booking .js-destination-item")
      .forEach(function (item) {
        item.value = "";
      });

    document
      .querySelectorAll(".js-hotel-booking .js-nationality-item")
      .forEach(function (item) {
        item.value = "ایران";
      });

    document
      .querySelectorAll(".js-hotel-booking .js-hotel-datepicker .form-control")
      .forEach(function (item) {
        item.value = "";
      });
  }, 10);
}
